const FieldErrorMsgs = {
  firstName: 'Please fill in first name',
  lastName: 'Please fill in last name',
  city: 'Please fill in city',
  street: 'Please fill in address',
  state: 'Please select State',
  district: 'Please fill in District',
}

const excludeList = {
  city: ['HK', 'SG'],
  postcode: ['AE', 'HK'],
  state: ['HK', 'SG', 'AE'],
  district: ['HK'],
}

export const validateTextInput = (state, target, value) => {
  const countryDetails = state
    .allCountries.filter((country) => country.code === state.selectedAddress.country)
  const { phone_length: phoneLength, postcode_length: postCodeLength } = countryDetails[0]

  switch (target) {
    case 'firstName':
    case 'lastName':
    case 'city':
    case 'street':
    case 'district':
    case 'state':
      if (!value && !value.length) {
        return {
          [target]: FieldErrorMsgs[target],
        }
      }
      return {
        [target]: false,
      }
    case 'phone':
      if (!phoneLength.includes(value.length)) {
        const errorMsg = {
          min: `minimum ${phoneLength[0]}`,
          max: `upto ${phoneLength[phoneLength.length - 1]}`,
        }
        return {
          [target]: value.length ? `Phone number should be ${value.length > phoneLength[phoneLength.length - 1] ? errorMsg.max : errorMsg.min} digits` : 'Please fill in Phone Number',
        }
      }
      return {
        [target]: false,
      }
    case 'postCode':
      if (postCodeLength && postCodeLength !== value.length) {
        return {
          [target]: value.length ? `Post code should be ${value.length > postCodeLength ? 'upto' : 'minimum'} ${postCodeLength} digits` : 'Please fill in post code',
        }
      }
      return {
        [target]: false,
      }
    default:
      return true
  }
}

export const validateAllFields = (state) => {
  const { selectedAddress, allCountries } = state
  const { country } = selectedAddress
  const errors = {
    firstName: !selectedAddress.firstName.length && FieldErrorMsgs.firstName,
    lastName: !selectedAddress.lastName.length && FieldErrorMsgs.lastName,
    street: !selectedAddress.street.length && FieldErrorMsgs.street,
    landmark: false,
    city: excludeList.city && !excludeList.city.includes(country)
      && !selectedAddress.city.length && FieldErrorMsgs.city,
    state: excludeList.state && !excludeList.state.includes(country)
      && !selectedAddress.state.length && FieldErrorMsgs.state,
    country: false,
    postCode: false,
    postBox: false,
    phone: false,
    district: excludeList.district && excludeList.district.includes(country)
      && !selectedAddress.district.length && FieldErrorMsgs.district,
  }

  const countryDetails = allCountries
    .filter((c) => c.phone_code === state.countryCode)
  const { phoneLength, postCodeLength } = countryDetails[0]
  if (excludeList.postcode && !excludeList.postcode.includes(country)
        && postCodeLength && postCodeLength !== selectedAddress.postCode.length) {
    errors.postCode = selectedAddress.postCode.length ? `Post code should be ${selectedAddress.postCode.length > postCodeLength ? 'upto' : 'minimum'} ${postCodeLength} digits` : 'Please fill in post code'
  }

  // if (phoneLength && phoneLength.length !== selectedAddress.phone.length) {
  if (phoneLength && !phoneLength.includes(selectedAddress.phone.length)) {
    const errorMsg = {
      min: `minimum ${phoneLength[0]}`,
      max: `upto ${phoneLength[phoneLength.length - 1]}`,
    }
    errors.phone = selectedAddress.phone.length ? `Phone number should be ${selectedAddress.phone.length > phoneLength[phoneLength.length - 1] ? errorMsg.max : errorMsg.min} digits` : 'Please fill in Phone Number'
  }

  return errors
}
